import * as Sentry from '@sentry/angular';

const REDACTED_KEYS = new Set<string>([]);

/**
 * Reports an error to Sentry, wrapping non-Error values (e.g. raw API error
 * objects, HttpErrorResponse) in a proper Error first — Sentry.captureException
 * on a plain object produces an unreadable "Object captured as exception" event.
 */
export function captureApiException(error: unknown, extra?: Record<string, unknown>): void {
    const sentryError = error instanceof Error ? error : new Error((error as { message?: string })?.message ?? 'Unknown API error');
    Sentry.captureException(sentryError, { extra: { ...extra, apiError: error } });
}

/**
 * Converts a FormData to a plain object safe to attach to Sentry events.
 * - Binary entries (File, Blob) are replaced with a placeholder showing the filename and size.
 * - Sensitive keys are redacted.
 */
export function serializeFormData(formData: FormData): Record<string, unknown> {
    const result: Record<string, unknown> = {};

    formData.forEach((value, key) => {
        if (REDACTED_KEYS.has(key)) {
            result[key] = '[REDACTED]';
        } else if (value instanceof File) {
            result[key] = `[File: ${value.name}, ${value.size}B]`;
        } else {
            result[key] = value;
        }
    });

    return result;
}
